/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { TaskDto } from '@/commons/dtos';
import TaskIcon from '@/components/TaskIcon';
import TaskTitle from '@/components/TaskTitle/TaskTitle';
import { useTranslations } from '@/hooks/useTranslations';
import { Card, FlexBox, Text } from '@ui5/webcomponents-react';

export default function IllustrationImage({ content }: { content: TaskDto }) {
    const { t } = useTranslations();
    const imageSrc = content.controlType?.controlTypeOptions?.[0].value;

    return (
        <Card>
            <FlexBox direction="Column" alignItems="Center" style={{ padding: '16px 16px 40px' }}>
                {content.iconLink && <TaskIcon icon={content.iconLink} />}
                <TaskTitle />
                <Text>{t({ key: content.translationTitleKey, defaultText: content.title })}</Text>
                {imageSrc && <img style={{ marginTop: 32 }} src={imageSrc} />}
            </FlexBox>
        </Card>
    );
}
